var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"discover-state compact"},[_c('i',{staticClass:"el-icon-files"}),_c('strong',[_vm._v(_vm._s(_vm.text))]),(_vm.description)?_c('p',[_vm._v(_vm._s(_vm.description))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }